// chat requirements
export const chatInitialState = {
  reloadChatPanel: false, // for reload right panel after update require reposne
  reloadConversationLeftPanel: false, // for reload left panel after leave group
  afterLeaveGroupReload: false, // for reload left panel after leave group
  isUnreadActive: false, // for unread message title change
  requireResponseChatIds: [], // for remove require response
};

export const chatReducer = (state, action) => {
  switch (action.type) {
    case "SET_RELOAD_CHAT_PANEL":
      return { ...state, reloadChatPanel: action.payload }; // for reload right panel after update require reposne
    case "SET_RELOAD_CONVERSATION_LEFT_PANEL":
      return { ...state, reloadConversationLeftPanel: action.payload }; // for reload left panel after leave group
    case "SET_AFTER_LEAVE_GROUP_RELOAD":
      return { ...state, afterLeaveGroupReload: action.payload }; // for reload left panel after leave group
    case "SET_IS_UNREAD_ACTIVE":
      return { ...state, isUnreadActive: action.payload }; // for unread message title change
    case "SET_REQUIRE_RESPONSE_CHAT_IDS":
      return { ...state, requireResponseChatIds: action.payload }; // for remove require response
    default:
      return state;
  }
};
